module.exports = __webpack_public_path__ + "static/media/Ilustración de portada_Apurimac_edited.6edbfd13.jpg";